var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "navbar py-4" }, [
    _c(
      "div",
      {
        staticClass:
          "container d-flex flex-row align-items-center justify-content-between"
      },
      [
        _c(
          "router-link",
          { staticClass: "logo", attrs: { to: { name: "home" }, tag: "a" } },
          [
            _c("img", {
              staticClass: "h-100",
              attrs: { src: "/site-logo.svg", alt: "Juodeliai" }
            })
          ]
        ),
        _vm._v(" "),
        _c("nav", { staticClass: "d-xl-flex flex-row d-none" }, [
          _c("ul", { staticClass: "d-flex nav-list align-items-center" }, [
            _c("li", [
              _c(
                "button",
                {
                  staticClass: "nav-link",
                  class: { "active-btn": _vm.activeSidebar === "contacts" },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$emit("showContacts")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.contactsLabel")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.userLoadStatus === 1
                ? _c("div", { staticClass: "user-icon user-icon--skeleton" })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "li",
              [
                !_vm.user
                  ? _c(
                      "router-link",
                      {
                        staticClass:
                          "btn btn-primary d-flex align-items-center justify-content-center",
                        attrs: { to: { name: "login" }, tag: "button" }
                      },
                      [
                        _c("i", { staticClass: "fas fa-sign-in-alt mr-2" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("common.loginLabel")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          !!_vm.user
            ? _c("div", { staticClass: "position-relative" }, [
                _c(
                  "button",
                  {
                    staticClass: "nav-link",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.makeActiveMenu("user")
                      }
                    }
                  },
                  [_c("i", { staticClass: "far fa-user-circle" })]
                ),
                _vm._v(" "),
                _vm.showUserMenu
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.close,
                            expression: "close"
                          }
                        ],
                        staticClass: "user-menu"
                      },
                      [
                        _vm.isAdmin
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-dropdown d-flex align-items-center justify-content-between",
                                attrs: { type: "button" },
                                on: { click: _vm.redirectToBO }
                              },
                              [_vm._m(0)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-dropdown d-flex align-items-center justify-content-between",
                            attrs: { to: { name: "profile" }, tag: "button" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between"
                              },
                              [
                                _c("i", { staticClass: "icon fas fa-user" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.profileLabel")) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-dropdown d-flex align-items-center justify-content-between",
                            attrs: {
                              to: { name: "reservations" },
                              tag: "button"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between"
                              },
                              [
                                _c("i", { staticClass: "icon fas fa-list-ol" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("common.reservationHistoryLabel")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-dropdown d-flex align-items-center justify-content-between",
                            attrs: { type: "button" },
                            on: { click: _vm.logout }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between"
                              },
                              [
                                _c("i", {
                                  staticClass: "icon fas fa-sign-out-alt"
                                }),
                                _vm._v(
                                  "\n\n              " +
                                    _vm._s(_vm.$t("common.logoutLabel")) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-xl-none ml-auto flex-row d-flex" }, [
          _c(
            "button",
            {
              staticClass: "nav-link",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.showMobileMenu = !_vm.showMobileMenu
                }
              }
            },
            [_c("i", { staticClass: "fas fa-bars" })]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "on-clickaway",
                rawName: "v-on-clickaway",
                value: _vm.hideMobileMenu,
                expression: "hideMobileMenu"
              }
            ],
            staticClass: "drawer-nav drawer-nav--left",
            class: { "is-open": _vm.showMobileMenu }
          },
          [
            _c("div", { staticClass: "drawer-nav__wrapper" }, [
              _c("div", { staticClass: "w-100" }, [
                _c(
                  "div",
                  [
                    _c(
                      "button",
                      {
                        staticClass: "sidebar-button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$emit("showContacts")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.contactsLabel")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !!_vm.user
                      ? _c(
                          "div",
                          [
                            _vm.isAdmin
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "sidebar-button",
                                    attrs: { type: "button" },
                                    on: { click: _vm.redirectToBO }
                                  },
                                  [_vm._m(1)]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "sidebar-link",
                                attrs: { to: { name: "profile" } }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-user icon"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.profileLabel")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "sidebar-link",
                                attrs: { to: { name: "reservations" } }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-list-ol icon"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.reservationHistoryLabel"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sidebar-button",
                                attrs: { type: "button" },
                                on: { click: _vm.logout }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon fas fa-sign-out-alt"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.logoutLabel")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c(
                          "router-link",
                          {
                            staticClass: "sidebar-link",
                            attrs: { to: { name: "login" } }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between"
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-sign-in-alt icon"
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.loginLabel")) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [
        _c("i", { staticClass: "icon fas fa-user-lock" }),
        _vm._v("\n\n              Backoffice\n            ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [
        _c("i", { staticClass: "fas fa-user-lock icon" }),
        _vm._v("\n                  Backoffice\n                ")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }